import { createSelector } from 'reselect';

import { selectUserType } from './selectUserType';

export const selectIsUserInCPD = createSelector(selectUserType, userType => {
  const isUserSearcher = userType === 'searcher';
  const isUserHomeowner = userType === 'homeowner';

  return isUserSearcher || isUserHomeowner;
});
